import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { UnitDataPayload, UnitDataResponse } from "@/types/interface/unit";

export const useUnitStore = defineStore("unitStore", () => {
  const unit = ref<UnitDataResponse>();
  const units = ref<UnitDataResponse[]>([]);

  function initUnits(data: any) {
    units.value = data?.data;
  }

  function addNewUnit(data: any) {
    unit.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.unit.getUnit(page, limit, queryParam);
      if (status === 200 ) {
        initUnits(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idUnit = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.unit.findUnit(idUnit);
      if (status === 200 ) {
        addNewUnit(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: UnitDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.unit.createUnit(payload);
      if (status === 200 ) {
        addNewUnit(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idUnit = "", payload: UnitDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.unit.updateUnit(idUnit, payload);
      if (status === 200 ) {
        addNewUnit(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idUnit = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.unit.deleteUnit(idUnit);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    unit,
    units,
    initUnits,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});